import { render } from "./insurance-checker.vue?vue&type=template&id=2e2f8438"
import script from "./insurance-checker.vue?vue&type=script&lang=js"
export * from "./insurance-checker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__